<template>
  <el-dialog title="新增快捷功能" :visible.sync="dialogVisible" width="520px" @close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入功能名称" />
      </el-form-item>
      <el-form-item label="图标" prop="icon">
        <el-input v-model="form.icon" placeholder="支持图标类名或图片地址" />
      </el-form-item>
      <el-form-item label="排序" prop="seq">
        <el-input v-model="form.seq" placeholder="数字越小越靠前" />
      </el-form-item>
      <el-form-item label="跳转地址" prop="url">
        <el-input v-model="form.url" placeholder="如 /pages/mall/couponCenter 或 https://..." />
      </el-form-item>
      <el-form-item label="是否启用" prop="isShow">
        <el-select v-model="form.isShow" style="width: 100%" placeholder="请选择">
          <el-option label="是" value="Y" />
          <el-option label="否" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addQuickMenu } from '@/api/dev/quickMenuApi'

export default {
  name: 'AddQuickMenu',
  emits: ['update:visible', 'success'],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        icon: '',
        seq: '1',
        url: '',
        isShow: 'Y'
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        icon: [{ required: true, message: '请输入图标', trigger: 'blur' }],
        seq: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        url: [{ required: true, message: '请输入跳转地址', trigger: 'blur' }],
        isShow: [{ required: true, message: '请选择是否启用', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val
      },
      immediate: true
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$refs.form && this.$refs.form.resetFields()
      this.form = {
        name: '',
        icon: '',
        seq: '1',
        url: '',
        isShow: 'Y'
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        await addQuickMenu(this.form)
        this.$message.success('新增成功')
        this.handleClose()
        this.$emit('success')
      } catch (error) {
        console.error('add quick menu failed', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}
</style>